var __WEBPACK_NAMESPACE_OBJECT__ = dependencies['@wh/ui-translations']['0.4']['module'];